<template>
    <div v-if="collections.length > 0">
        <notifications :show="['booking']"></notifications>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" v-for="collection in collections">

                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="box-layout-inner">
                        <div class="title-block">
                            {{ collection.year }}
                        </div>
                    </div>
            </div>

                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" v-for="payment in collection.payments">
                    <div class="box-layout-inner payment-tabs">
                        <ul class="content-links">
                            <li>
                                <router-link :to="{ name: 'account.bookings.view', params: { bookingId: payment.booking_id }, query: { payments: true} }">
                                    <span class="info-tab" data-tooltipOver="1"><i class="fa fa-calendar"></i></span>
                                    <span class="title">
                                        <span v-html="payment.payment_date.toDate().toDateString()"></span>
                                    </span>
                                    <span class="venue-location">
                                        <span v-html="currencyFormat(payment.amount)"></span>
                                        <br /><b>{{ payment.payment_state_description }}</b>
                                    </span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
            </div>
        </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-else-if="loading">
        <p class="text-center"><i class="fa fa-spinner fa-pulse fa-5x dark"></i></p>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                loading: true,

                collections: [],
            }
        },
        components: {
            'notifications': require('../Notifications.vue')
        },
        computed: {
            locale: function () {
                return this.$root.locale.account.payments;
            }
        },
        methods: {
            currencyFormat: function ( value ) {
                return (value < 0 ? '- ' : '') + '£' + Math.abs(value).toFixed(2);
            },
        },
        created () {

            /**Checking if the user is currently logged in**/
            axios.get('/camp-booking/users/current')
                .then(response => {
                    if(response.data.data.user_id == null) {
                        this.$router.push({name: 'auth.login'});
                        return false;
                    }
                })

            /**
             * Getting the payments
             **/
            axios.get('/camp-booking/users/'+this.$root.auth.user_id+'/payments?hide_completed=false&hide_cancelled=true&hide_failed=false&hide_transferred=true&hide_pending=false&desc=payment_date')
                .then(response => {
                    var temp = {};
                    response.data.data.forEach(payment => {
                        let date = payment.payment_date.toDate();
                        let payments = (temp.hasOwnProperty(date.getFullYear()) ? temp[date.getFullYear()].payments.concat([payment]) : [payment]);
                        temp[date.getFullYear()] = {
                            year: date.getFullYear(),
                            payments: payments.reverse()
                        }
                    })
                    this.collections = Object.keys(temp).map(key => { return temp[key]; });
                    if(this.collections) {
                        this.collections.forEach(($collection, $key) => {
                            $collection.payments.sort(function(a,b) { return a.payment_date.toDate().getTime() - b.payment_date.toDate().getTime();} );
                            this.collections[$key].payments = $collection.payments;
                        });
                    } else {
                        this.$root.alert(this.locale.text_payments_empty, 'danger', false, true, true);
                    }
                    this.loading = false;
                })

            /**
             * Setting the headers
             */
            this.$root.headers = {
                navigate: {
                    name: 'account.overview'
                },
                title: this.$root.locale.miscellaneous.page_headings.account.view_all_payments
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Payments.vue?fddfc990